exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".bp-setting-modal-tab-general__field{background-color:#fff}.bp-setting-modal-tab-general__field.logo-row{margin:20px 0}.bp-setting-modal-tab-general__field .logo-img{height:100px;border-radius:50%;width:100px;border:solid 2px #fff;box-shadow:0 2px 10px 2px lightgrey;margin:0}.bp-setting-modal-tab-general__field.toggle-option{width:270px}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/Header/SettingModal/SettingModalTabGeneral/SettingModalTabGeneral.scss
 ** module id = 273
 ** module chunks = 0
 **/